/*
 * Copyright (c) 2022. CodeGen International (Pvt) Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of CodeGen
 * International (Pvt) Ltd. ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with CodeGen International.
 *
 */
import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { TCO } from '../../../../constants';
import { ConfigLoader } from '@tc-core/util/framework';
import { SetupGridComp } from '../../../../widgets/framework/ag-grid-custom-components/components/setup-grid/setup-grid-comp';
import { JobService } from '../../../../services/backend-consumers/job/job-service';
import { JobParameterSearchCriteria } from '../../../../models/criteria/job-parameter-search-criteria';
import { tap } from 'rxjs/operators';
import { DataKey, DataStoreService } from '../../../../services/util/framework/data-store.service';
import { of } from 'rxjs';
/**
 * @author lakshan
 * @since 08 Nov, 2022
 */
var JobParameterFocusViewComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JobParameterFocusViewComponent, _super);
    function JobParameterFocusViewComponent(configLoader, jobService, dataStoreService) {
        var _this = _super.call(this) || this;
        _this.configLoader = configLoader;
        _this.jobService = jobService;
        _this.dataStoreService = dataStoreService;
        _this.pageSize = 20;
        _this.searchPage = 0;
        _this.sortBy = 'id';
        _this.sortDirection = 'ASC';
        _this.colDefConfig = [];
        _this.jobParameterSearchCriteria = new JobParameterSearchCriteria();
        return _this;
    }
    JobParameterFocusViewComponent.prototype.ngOnInit = function () {
        // Load Job Parameter grid configs
        this.colDefConfig = this.configLoader.configurations.get(TCO.CONF.CONF_JOB_PARAMETER_GRID);
    };
    JobParameterFocusViewComponent.prototype.createNewRow = function () {
        return { unsaved: true };
    };
    JobParameterFocusViewComponent.prototype.isInvalidRow = function (params) {
        return false;
    };
    JobParameterFocusViewComponent.prototype.isUnsavedRow = function (row) {
        return false;
    };
    JobParameterFocusViewComponent.prototype.deleteRow = function (row) {
        if (row && row.id) {
            return this.jobService.deleteJobParameter(row.id);
        }
        else {
            return of('success');
        }
    };
    JobParameterFocusViewComponent.prototype.getRows = function (params) {
        var _this = this;
        if (this.data && this.data.jobName) {
            this.jobParameterSearchCriteria.jobName = this.data.jobName;
        }
        return this.jobService.getJobParameter(this.jobParameterSearchCriteria).pipe(tap(function (data) {
            return _this.dataStoreService.set(DataKey.jobParameterSearchResults, data);
        }));
    };
    JobParameterFocusViewComponent.prototype.saveRow = function (row, event) {
        if (this.data) {
            row.jobName = this.data.jobName;
        }
        return this.jobService.addJobParameter(row);
    };
    return JobParameterFocusViewComponent;
}(SetupGridComp));
export { JobParameterFocusViewComponent };
